import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  name: validatePresence({ presence: true, message: 'This is a required field' }),
  description: validatePresence({ presence: true, message: 'This is a required field' }),
};
